import { render } from "./ClientConfiguracionUsuarios.vue?vue&type=template&id=5b16c882&scoped=true"
import script from "./ClientConfiguracionUsuarios.vue?vue&type=script&lang=js"
export * from "./ClientConfiguracionUsuarios.vue?vue&type=script&lang=js"

import "./ClientConfiguracionUsuarios.vue?vue&type=style&index=0&id=5b16c882&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b16c882"]])

export default __exports__